import PropTypes from 'prop-types'
import { defaultTheme } from 'react-select'

// NOTE: This wrapper is used for 'react-select'  component compatibility with styled-components v6.
// See next issue for details: https://github.com/styled-components/styled-components/issues/4074
export const InnerComponent = ({ Component, ...props }) => (
  <Component theme={defaultTheme} {...props} />
)

InnerComponent.propTypes = {
  Component: PropTypes.func,
}
